import React from "react";
import {Field, Formik} from "formik";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AEDatePicker, AEInput} from "../../../../../_metronic/_partials/controls";
import {AESVG} from "../../../../../_emywork/components/svg";
import {Tooltip} from "react-bootstrap";
import {useIntl} from "react-intl";
import {AEOverlayTrigger} from "../../../../../_emywork/AEOverlayTrigger";


const initValues = {
  search: "",
  created_at: undefined,
  updated_at: undefined,

}

export function Filter({ filters,  setFilters, setSearch, setCreatedAt, ...props }) {
  const {formatMessage} = useIntl()

  return (
    <>
      <Formik
        initialValues={initValues}
        onSubmit={(values) => {
          setFilters(values)
        }}
      >
        {({ handleSubmit, resetForm }) => (
          <form className="d-flex">
            <div className={"pr-2"}>
              <Field
                name={"search"}
                component={AEInput}
                validation={false}
                label={'SEARCH'}
                autoComplete="false"
                withFeedbackLabel={false}
                shrinkLabel
              />

            </div>
            <div className={"pr-2"}>
              <Field
                type={'date'}
                name={"created_at"}
                component={AEDatePicker}
                validation={false}
                label='CREATED_AT'
                shrinkLabel
                withFeedbackLabel={false}
              />
            </div>
            <div className={"pr-2"}>
              <Field
                type={'date'}
                name={"updated_at"}
                component={AEDatePicker}
                validation={false}
                label='UPDATED_AT'
                shrinkLabel
                withFeedbackLabel={false}
              />
            </div>
            <div className={"pr-2"}>
              <AEOverlayTrigger
                overlay={ <Tooltip id={`tooltip_filter_apply`}>{formatMessage({id:"APPLY"})}</Tooltip> }
              >
                <div>
                  <AEButton variant={"light"} fontWeight={"bolder"} onClick={handleSubmit} icon>
                    <AESVG path={"/Navigation/Check.svg"} variant={"primary"}/>
                  </AEButton>
                </div>
              </AEOverlayTrigger>
            </div>
            <div className={""}>
              <AEOverlayTrigger overlay={ <Tooltip id={`tooltip_filter_reset`}>{formatMessage({id:"RESET"})}</Tooltip> } >
                <div>
                  <AEButton variant={"light"} fontWeight={"bolder"} onClick={e =>{
                    resetForm(); handleSubmit();
                  }} icon>
                    <AESVG path={"/General/Update.svg"} variant={"primary"}/>
                  </AEButton>
                </div>
              </AEOverlayTrigger>
            </div>
          </form>

        )}
      </Formik>

    </>
  );
}
